import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"

export const getInventarioGeneralQC = async () => {
   return PrivateInterceptor('Produccion/QC/getInventarioGeneral', 'GET');
}
 